import { ChangeDetectionStrategy, Component, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { INC_EXC_KIND } from '@wizeoo/akm-common-lib';
import { IncExcMainObj } from '@wizeoo/akm-common-lib';

/**
 * renderer FD ou chrono (icone selon le Kind)
 */
@Component({
  selector: 'incex-kind-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center" horizontalAlign="center">
    <wiz-icon *ngIf="isFD()" height="16px">codifications</wiz-icon>
    <wiz-icon *ngIf="isChron()" height="16px">chronocodes</wiz-icon>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncExcKindRenderer implements AgRendererComponent {
  data: IncExcMainObj;

  public isFD(): boolean {
    return !!this.data && this.data.kind === INC_EXC_KIND.FD;
  }

  public isChron(): boolean {
    return !!this.data && this.data.kind === INC_EXC_KIND.CHRO;
  }

  constructor(private cdref: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.cdref.markForCheck();
  }
}
